import "chart.js/auto";
import CumulativeTransactionPresenter from "./CumulativeTransactionPresenter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import BaseListPage from "../../../base/BaseListPage";
import withRouter from "../../../withRouter";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import GuestTransactionReport from "./components/GuestTransactionReport";
import MonthSelect from "./components/MonthSelect";
import YearSelect from "../../discount-cost/salesDiscountAmount/components/YearSelect";
import { exportCumulativeTransactionsCSV } from "./utils/cumulativeCsvUtils";
import ProgressLoader from "../../../components/ProgressLoader";

class CumulativeTransactionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CumulativeTransactionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selectedStoreCode: "",
      selectedMonth: "",
      selectedYear: "",
      store: [],
      storess: "",
      range: "",
      selectedMonth: "",
      selectedMonthName: "",
      notFound: false,
    };
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );

    return [...new Set(storeCodes)];
  }

  handleDropdownChange(event) {
    const monthNames = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    let monthName;
    this.setState({ selectedMonth: event.target.value });
    // console.log("b", event.target.value)

    if (event.target.value === "AllMonths") {
      this.presenter.onChangeDate("AllMonths");
    } else {
      this.setState({ range: event.target.value });
      this.presenter.onChangeDate(JSON.parse(event.target.value));
      const monthi = JSON.parse(event.target.value).$gte.split("-");
      monthName = Object.keys(monthNames).find(
        (key) => monthNames[key] === monthi[1]
      );
    }

    this.setState({ selectedMonthName: monthName });
  }

  getMonthOptions() {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.map((month) => (
      <option key={month} value={month}>
        {month}
      </option>
    ));
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  handleYearChange = (event) => {
    const year = event.target.value; // Assuming year is a string like "2024"

    // Assuming 'range' is a JSON string that needs to be parsed
    let parsedRange = JSON.parse(this.state.range);

    // Concatenate the year with the rest of the date, including the dash
    parsedRange.$gte =
      year + parsedRange.$gte.substring(parsedRange.$gte.indexOf("-"));
    parsedRange.$lte =
      year + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));

    this.presenter.onChangeDate(parsedRange);
    this.setState({ selectedYear: event.target.value });
  };

  countTransactionTypesFromMonth = (transactions, month, year) => {
    const { objects, selectedStoreCode, selectedMonth, selectedYear } =
      this.state;

    // Filter data based on the selected store, month, and year
    const filteredSales = objects
      .filter((status) => status.status === "C")
      .filter((sale) => {
        const saleDate = new Date(sale.tran_date);
        const saleYear = saleDate.getFullYear();
        const saleMonth = saleDate.toLocaleString("default", { month: "long" });
        const saleStoreCode = sale.store_code.replace("ANGELSPIZZA_", "");

        const yearMatches = selectedYear
          ? saleYear === parseInt(selectedYear)
          : true;
        const monthMatches = selectedMonth
          ? saleMonth === this.state.selectedMonthName
          : true;
        const storeMatches = selectedStoreCode
          ? saleStoreCode === selectedStoreCode
          : true;

        return yearMatches && monthMatches && storeMatches;
      });

    const cumulative = filteredSales;

    // console.log("cimu", cumulative);

    let totalGuest = 0;
    let totalTransaction = 0;

    cumulative.forEach((transaction) => {
      const transactionDate = new Date(transaction.tran_date);

      if (
        transactionDate.toLocaleString("default", { month: "long" }) ===
          this.state.selectedMonthName &&
        transactionDate.getFullYear() === year
      ) {
        const name = transaction.cust_name?.trim();
        if (name && name !== "-") {
          totalGuest += 1;
        }
        console.log("totalTransaction", totalTransaction);
        totalTransaction += 1;
      }
    });

    return { totalGuest, totalTransaction };
  };

  months() {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthsFormatted = monthNames.map((name, index) => {
      const monthNumber = (index + 1).toString().padStart(2, "0");
      const firstDayOfMonth = `${this.state.selectedYear}-${monthNumber}-01T00:00:00.000Z`;

      // Calculate the last day of the month
      const lastDayOfMonthDate = new Date(
        this.state.selectedYear,
        index + 1,
        0
      ); // The 0 here gets the last day of the previous month, i.e., the month we're interested in
      // const lastDayOfMonth = `${lastDayOfMonthDate.getFullYear()}-${(lastDayOfMonthDate.getMonth() + 1).toString().padStart(2, '0')}-${lastDayOfMonthDate.getDate().toString().padStart(2, '0')}T23:59:59.999Z`;
      const lastDayOfMonth = `${this.state.selectedYear}-${(
        lastDayOfMonthDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${lastDayOfMonthDate
        .getDate()
        .toString()
        .padStart(2, "0")}T23:59:59.999Z`;

      return {
        name, // The display name of the month
        tran_date: {
          $gte: firstDayOfMonth,
          $lte: lastDayOfMonth,
        },
      };
    });

    return monthsFormatted;
  }

  getChartData() {
    const newCounts = this.countTransactionTypesFromMonth(this.state.objects);

    const currentDate = new Date();
    const monthsToShow = 3; // Number of months you want to show including the current month
    const labels = [];

    for (let i = monthsToShow - 1; i >= 0; i--) {
      // Get the first day of each month
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      );
      // Format it as 'Month Year'
      labels.push(
        date.toLocaleString("default", { month: "long", year: "numeric" })
      );
    }

    return {
      labels,
      datasets: [
        {
          label: "Total Guest",
          data: labels.map((label) => {
            const date = new Date(label);
            return this.countTransactionTypesFromMonth(
              this.state.objects,
              date.getMonth(),
              date.getFullYear()
            ).totalGuest;
          }),
          borderColor: "#1b74bb",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          fill: true,
        },
        {
          label: "Total Transaction",
          data: labels.map((label) => {
            const date = new Date(label);
            return this.countTransactionTypesFromMonth(
              this.state.objects,
              date.getMonth(),
              date.getFullYear()
            ).totalTransaction;
          }),
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
          fill: true,
        },
      ],
    };
  }

  getChartOptions() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Total Transactions vs Time of Day (Hours)",
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  }

  exportToCSV = () => {
    const { range, selectedYear, storess } = this.state;

    const chartData = this.getChartData();

    exportCumulativeTransactionsCSV({
      chartData,
      selectedYear,
      range,
      storess,
      fileName: "Cumulative.csv",
    });
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const {
      objects,
      selectedStoreCode,
      selectedMonthName,
      selectedMonth,
      selectedYear,
      storess,
    } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();

    const chartId = "chart-container12";

    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "#83c14a" }}>Cumulative</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Transaction</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
          <MonthSelect
            selectedMonth={selectedMonth}
            selectedMonthName={selectedMonthName}
            months={this.months()}
            onChange={this.handleDropdownChange}
          />
          <YearSelect
            selectedYear={this.state.selectedYear}
            onChange={this.handleYearChange.bind(this)}
            yearsCount={3}
            className="col-sm-3"
          />
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <GuestTransactionReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            chartRef={this.chartRef12}
            containerId="chart-container12"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.objects?.length === 0 &&
          this.state.selectedMonthName &&
          this.state.selectedYear &&
          this.state.storess &&
          !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={false} />
        )}
      </>
    );
  }
}

export default withRouter(CumulativeTransactionPage);
